
import { GeoIPInfo } from '@luxtag/papybase';
import { find } from 'lodash';

export const MUTATE_GEOIPS = 'MUTATE_GEOIPS';
export const ADD_IPAPI = 'ADD_IPAPI';

export interface IPAPI {
    ip: string;
    type: string;
    continent_code: string;
    continent_name: string;
    country_code: string;
    country_name: string;
    region_code: string;
    region_name: string;
    city: string;
    zip: string;
    latitude: string;
    longitude: string;
    location: {
        geoname_id: string;
        capital: string;
        languages: [
            {
                code: string;
                name: string;
                native: string;
            }
        ],
        country_flag: string;
        country_flag_emoji: string;
        country_flag_emoji_unicode: string;
        calling_code: number;
        is_eu: boolean;
    }
}

interface GeoIPState {
    geoIPs: GeoIPInfo[];
    ipAPIs: IPAPI[];
}

// initial state
const geoIPState: GeoIPState = {
    geoIPs: [],
    ipAPIs: [],
};

// getters
const getters = {
    getGeoIPs: (state: GeoIPState) => state.geoIPs,
    getGeoIP: (state: GeoIPState) => (id: any) => find(
        state.geoIPs, (geoIP: GeoIPInfo) => geoIP.id === id,
    ),
    getIPAPIs: (state: GeoIPState) => state.ipAPIs,
    getIPAPI: (state: GeoIPState) => (ipAddress: any) => find(
        state.ipAPIs, (ipAPI: IPAPI) => ipAPI.ip === ipAddress,
    ),
};

// mutations
const mutations = {
    [MUTATE_GEOIPS](state: GeoIPState, payload: GeoIPInfo[]) {
        state.geoIPs = payload;
    },
    [ADD_IPAPI](state: GeoIPState, payload: IPAPI) {
        state.ipAPIs.push(payload);
    },
};

// actions
const actions = {
    [MUTATE_GEOIPS](context: any, payload: any) {
        context.commit(MUTATE_GEOIPS, payload);
    },
    [ADD_IPAPI](context: any, payload: any) {
        context.commit(ADD_IPAPI, payload);
    },
};


export default {
    state: geoIPState,
    getters,
    actions,
    mutations,
};
